export default __webpack_public_path__ + "static/media/asa-sessions-3x.d24efd06.png";